// extracted by mini-css-extract-plugin
export default {"loader":"D8Q4xY","stroke1":"xdSF_1","rotate":"c4WlFX","stroke2":"jr8CBO"};